import { LegalDoc } from '@/components/LegalDoc';

export function PrivacyPolicyPage() {
  return (
    <LegalDoc title="Политика обработки персональных данных" effectiveFrom="01.01.2026">
      <p>
        Настоящая Политика обработки персональных данных (далее — «Политика») разработана
        в соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных
        данных» (далее — «Закон») и определяет порядок обработки персональных данных и
        меры по обеспечению их безопасности, предпринимаемые оператором.
      </p>

      <h2>1. Оператор</h2>
      <p>
        Оператором персональных данных является администрация проекта Empire of Life,
        предоставляющая доступ к сайту <strong>empire-life.ru</strong> (далее — «Сайт»)
        и связанным с ним сервисам.
      </p>

      <h2>2. Какие данные обрабатываются</h2>
      <p>Оператор обрабатывает следующие категории данных:</p>
      <ul>
        <li>идентификаторы Discord (ID, имя пользователя, никнейм, аватар, email — если он публично доступен в Discord);</li>
        <li>выбранный Пользователем никнейм Minecraft;</li>
        <li>IP-адрес и технические метаданные обращения к Сайту и Серверу (User-Agent, время запроса);</li>
        <li>сведения о платежах и операциях по Внутреннему балансу (суммы, идентификаторы транзакций платёжных систем);</li>
        <li>история действий в магазине Сайта и на Сервере, необходимая для оказания услуг.</li>
      </ul>
      <p>
        Специальные категории персональных данных (расовое, национальное происхождение,
        политические взгляды, состояние здоровья и т.п.) не обрабатываются.
      </p>

      <h2>3. Цели обработки</h2>
      <ul>
        <li>заключение и исполнение соглашения с Пользователем (предоставление доступа к Серверу и Виртуальным товарам);</li>
        <li>проведение расчётов и учёт операций по внутреннему балансу;</li>
        <li>информирование Пользователя об изменениях в работе Сайта и Сервера;</li>
        <li>предотвращение мошенничества и иных противоправных действий;</li>
        <li>исполнение требований законодательства Российской Федерации.</li>
      </ul>

      <h2>4. Правовые основания обработки</h2>
      <ul>
        <li>согласие Пользователя (ст. 6 ч. 1 п. 1 Закона) — даётся фактом начала использования Сайта и подтверждается при авторизации;</li>
        <li>исполнение договора, стороной которого является субъект данных (ст. 6 ч. 1 п. 5 Закона);</li>
        <li>исполнение обязанностей, возложенных на Оператора законодательством РФ (ст. 6 ч. 1 п. 2 Закона).</li>
      </ul>

      <h2>5. Способ и сроки обработки</h2>
      <ul>
        <li>Обработка осуществляется с использованием средств автоматизации и без таковых.</li>
        <li>Хранение данных производится на серверах, расположенных на территории Российской Федерации, в соответствии с ч. 5 ст. 18 Закона.</li>
        <li>Срок хранения данных — на протяжении всего срока действия Пользовательского соглашения и в течение 3 (трёх) лет после его прекращения для целей разрешения возможных споров, а также в течение сроков, установленных налоговым законодательством.</li>
        <li>По истечении сроков обработки данные обезличиваются или уничтожаются.</li>
      </ul>

      <h2>6. Передача третьим лицам</h2>
      <p>Оператор может передавать персональные данные следующим категориям получателей:</p>
      <ul>
        <li>платёжные сервисы (ЮKassa, CryptoBot) — в объёме, необходимом для проведения платежа;</li>
        <li>сервисы аутентификации (Discord) — на стороне платформы Discord, в рамках OAuth2-протокола;</li>
        <li>государственные органы — по требованию законодательства РФ.</li>
      </ul>
      <p>
        Оператор не передаёт персональные данные в рекламных и маркетинговых целях
        третьим лицам без отдельного согласия субъекта данных.
      </p>

      <h2>7. Использование cookies и аналогичных технологий</h2>
      <p>
        Сайт использует cookie-файлы и аналогичные технологии (localStorage, JWT в
        httpOnly-cookie) для обеспечения работы авторизации, сохранения настроек
        пользователя и обеспечения безопасности. Cookie не используется в рекламных
        целях и не передаётся в системы поведенческой рекламы.
      </p>

      <h2>8. Права субъекта персональных данных</h2>
      <p>Пользователь имеет право:</p>
      <ul>
        <li>получать информацию о факте обработки его персональных данных, их составе и целях;</li>
        <li>требовать уточнения, блокирования или уничтожения своих данных в случае их неполноты, неточности, незаконного получения или излишнего объёма;</li>
        <li>отозвать ранее данное согласие на обработку (в этом случае использование Сайта станет невозможным);</li>
        <li>обжаловать действия Оператора в Роскомнадзоре или в судебном порядке.</li>
      </ul>
      <p>
        Запросы направляются по адресу: <a href="mailto:eol.servermc@gmail.com" className="text-eol-pink underline">eol.servermc@gmail.com</a>.
        Срок рассмотрения — не более 30 дней.
      </p>

      <h2>9. Меры по обеспечению безопасности</h2>
      <ul>
        <li>передача данных от пользователя к серверу осуществляется по защищённому протоколу HTTPS;</li>
        <li>пароли и платёжные секреты не хранятся в открытом виде; используются криптографические хеши и токены;</li>
        <li>доступ к административной части Сайта имеют только уполномоченные лица;</li>
        <li>ведётся аудит критичных операций (изменение баланса, изменение прав и т.п.).</li>
      </ul>

      <h2>10. Согласие и отзыв</h2>
      <p>
        Используя Сайт, Пользователь подтверждает своё согласие с настоящей Политикой и
        даёт согласие на обработку своих персональных данных на изложенных условиях.
        Согласие может быть отозвано путём направления заявления на email Оператора.
      </p>

      <h2>11. Изменение Политики</h2>
      <p>
        Оператор вправе вносить изменения в настоящую Политику. Актуальная редакция
        размещена на Сайте по постоянному адресу <strong>empire-life.ru/privacy-policy</strong>.
      </p>
    </LegalDoc>
  );
}
